var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5E6276",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.494 18h13.018c1.364 0 2.473-1.07 2.473-2.387V3.72c0-1.317-1.109-2.387-2.473-2.387h-.981V.667A.681.681 0 0 0 13.84 0c-.38 0-.691.3-.691.667v.666H4.857V.667A.681.681 0 0 0 4.167 0c-.38 0-.692.3-.692.667v.666h-.98C1.13 1.333.02 2.403.02 3.72v11.893C.02 16.93 1.13 18 2.494 18zM1.403 3.72c0-.58.49-1.053 1.091-1.053h.981v.666c0 .367.311.667.691.667.38 0 .691-.3.691-.667v-.666h8.292v.666c0 .367.31.667.69.667.38 0 .692-.3.692-.667v-.666h.98c.602 0 1.092.473 1.092 1.053v11.893c0 .58-.49 1.054-1.091 1.054H2.494c-.6 0-1.091-.474-1.091-1.054V3.72z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.03,
    cy: 6.833,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83,
    cy: 6.833,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.631,
    cy: 6.833,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.03,
    cy: 10.167,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83,
    cy: 10.167,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.631,
    cy: 10.167,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.03,
    cy: 13.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.83,
    cy: 13.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.631,
    cy: 13.5,
    r: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon-calendar.94a4965519208958f405e6ed3e817f6c.svg";
export { ForwardRef as ReactComponent };